// aws-exports.js
const config = {
    Auth: {
        Cognito: {
            region: process.env.REACT_APP_AWS_REGION,
            userPoolId: process.env.REACT_APP_USER_POOL_ID,
            userPoolClientId: process.env.REACT_APP_USER_CLIENT_ID,
            mandatorySignIn: true,
        },

        authenticationFlowType: 'USER_SRP_AUTH',
        oauth: {
            domain: process.env.REACT_APP_COGNITO_DOMAIN,
            scope: ['email', 'openid', 'profile', 'phone'],
            redirectSignIn: ['http://localhost:3000', 'https://scadaswarm.io', 'https://dev.scadaswarm.io', 'https://test.scadaswarm.io'],
            redirectSignOut: ['http://localhost:3000', 'https://scadaswarm.io', 'https://dev.scadaswarm.io', 'https://test.scadaswarm.io'],
            responseType: 'code'
        }
    }
};
export default config;